import { inject, ModuleWithProviders, NgModule } from '@angular/core';

import { WysiwygAdapterService } from './wysiwyg-adapter.service';
import type { WysiwygEmbeddableComponentType } from './wysiwyg-adapter.types';
import { WysiwygEmbeddableComponents } from './wysiwyg-adapter.types';

export const adapterServiceFactory = (
  parent = inject(WysiwygAdapterService, { optional: true, skipSelf: true }),
) => (parent ? parent : new WysiwygAdapterService());

export const ADAPTER_SERVICE_PROVIDER = {
  provide: WysiwygAdapterService,
  useFactory: adapterServiceFactory,
};

@NgModule()
export class WysiwygAdapterModule {
  public static provideEmbeddableComponent(
    component: WysiwygEmbeddableComponentType,
  ): ModuleWithProviders<WysiwygAdapterModule> {
    return {
      ngModule: WysiwygAdapterModule,
      providers: [
        {
          provide: WysiwygEmbeddableComponents,
          useValue: component,
          multi: true,
        },
        ADAPTER_SERVICE_PROVIDER,
      ],
    };
  }
}
